export default {
  methods: {
    setErrors({
      title = this.$t("error").toString(),
      text = this.$t("errorHasOccurred").toString(),
    }) {
      this.$notify({
        title,
        text,
        type: "error",
      });
    },
    setResponseError({ title = this.$t("error").toString(), error }) {
      // const timeout = setTimeout(() => {
      //   lastError = null
      // }, 3500)
      const text =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.error_message &&
        error.response.data.error_message.description;

      title =
        (error &&
          error.response &&
          error.response.data &&
          error.response.data.error_message &&
          error.response.data.error_message.title) ||
        this.$t("error").toString();
      // if (lastError !== text) {
      this.$notify({
        title,
        text,
        type: "error",
      });
      // lastError = text
      // clearTimeout(timeout)
      // }
    },
    /**
     *
     * @param title? {string}
     * @param text? {string}
     */
    setSuccess({ title, text }) {
      this.$notify({
        title: title,
        text: text,
      });
    },
  },
};
